import {
    CloudUploadOutlined,
    Loading3QuartersOutlined,
} from "@ant-design/icons";
import { Badge, Button } from "antd";
import { useCallback, useMemo } from "react";

import { QueueTaskStatus } from "@/hooks/core/useAsyncTaskQueue";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { addModalToQueue } from "@/store/slices/ui";
import { ModalType } from "@/types";

import { StyledUploadIndicator } from "./Styled";

export const UploadIndicator = () => {
    const { candidatesCount: photoCandidates, progress: photoProgress } =
        useAppSelector((state) => state.offline.photoUploadRetry);

    const requestQueue = useAppSelector((state) => state.offline.requestQueue);
    const requestQueueStatus = useAppSelector(
        (state) => state.offline.requestQueueStatus,
    );

    const dispatch = useAppDispatch();

    const { badgeCount, showSpinner, photoCount, requestCount } =
        useMemo(() => {
            const photoIsRunning = photoProgress.isRunning;
            const photoRemaining = Math.max(
                0,
                photoProgress.totalCount - photoProgress.completedCount,
            );

            const photoBadge = photoIsRunning
                ? photoRemaining
                : photoCandidates;

            const requestIsRunning = requestQueueStatus.isRunning;

            const requestCandidates = requestQueue.length;

            const requestRemaining = requestQueue.filter(
                (item) => item.status === QueueTaskStatus.Pending,
            ).length;

            const requestBadge = requestIsRunning
                ? requestRemaining
                : requestCandidates;

            return {
                badgeCount: photoBadge + requestBadge,
                showSpinner: photoIsRunning || requestIsRunning,
                requestCount: requestBadge,
                photoCount: photoBadge,
            };
        }, [
            photoProgress,
            photoCandidates,
            requestQueueStatus.isRunning,
            requestQueue,
        ]);

    const initialTab = useMemo(() => {
        if (photoCount > 0) return "photo";
        if (requestCount > 0) return "request";
        return "photo";
    }, [photoCount, requestCount]);

    const handleOpenModal = useCallback(() => {
        dispatch(
            addModalToQueue({
                id: ModalType.UploadRetry,
                type: ModalType.UploadRetry,
                payload: { initialTab },
            }),
        );
    }, [dispatch, initialTab]);

    return (
        <>
            <StyledUploadIndicator>
                <Badge count={badgeCount} size="small">
                    <Button
                        icon={
                            showSpinner ? (
                                <Loading3QuartersOutlined spin />
                            ) : (
                                <CloudUploadOutlined />
                            )
                        }
                        type="text"
                        onClick={handleOpenModal}
                    />
                </Badge>
            </StyledUploadIndicator>
        </>
    );
};
